/** @format */

import { useLocale } from "../features/i18n/hooks";
import { Image } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as WJECLogo } from "../assets/images/wjecLogo.svg";
import { ReactComponent as CBACLogo } from "../assets/images/cbacLogo.svg";
import MaintenanceIllustration from "../assets/images/errorPages/site-maintenance-illustration.svg";
import { LocaleText } from "../features/i18n/init";
import "../features/errorPage/ErrorPage.scss";

type Props = {
  message: LocaleText;
  Logo?: React.FC<{ className?: string }>;
};

const MaintenancePage: React.FC<Props> = ({ message, Logo }) => {
  const { t: _ } = useTranslation();
  const locale = useLocale();

  return (
    <main className="maintenanceContainer" data-testid="maintenance">
      <div className="container" data-testid="maintenanceNotification">
        <div className="error-container p-4 p-md-5" data-testid="error">
          <div className="error-message">
            {Logo !== undefined ? (
              <Logo className="logo" />
            ) : locale === "en" ? (
              <WJECLogo className="logo" />
            ) : (
              <CBACLogo className="logo" />
            )}

            <h4>{_("maintenancePageHeader")}</h4>
            <p>{_("maintenancePageMessage")}</p>
            <p className="text">{message[locale]}</p>
          </div>
          <div className="image-container">
            <Image
              src={MaintenanceIllustration}
              alt="maintenance illustration"
              className="error-illustration"
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default MaintenancePage;
